var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('b-card',{staticClass:"mb-5",attrs:{"title":_vm.title,"bg-variant":_vm.status}},[_c('b-card-text',_vm._l((_vm.datas),function(item,id){return _c('p',{key:`item_${id}`},[_vm._v(_vm._s(item.line || '')+" : "+_vm._s(item.message))])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }